import { Button } from "@/components/ui/button";
import { VehicleSummary } from "./EstimateCard";

export const ReviewOutcome = ({ outcome, onManual }) => {
  const declined = outcome.status === "not_buying";
  return (
    <div className="fade-in space-y-4 rounded-md border border-slate-300 bg-white p-4" role="status" data-testid={declined ? "outcome-not-buying" : "outcome-manual-review"}>
      {declined ? (
        <>
          <p className="text-base font-semibold text-slate-900">Thanks for checking with Harrington's Direct.</p>
          <p className="text-sm text-slate-700">Unfortunately, we're not currently purchasing this particular vehicle for outright sale. However, if you're looking to buy a car from us, we may still be able to consider it as a part-exchange.</p>
        </>
      ) : (
        <>
          <p className="text-base font-semibold text-slate-900">We'd like to take a closer look at your car.</p>
          <p className="text-sm text-slate-700">Your vehicle needs a quick personal valuation from our team. Leave your details and we'll be in touch.</p>
        </>
      )}
      <VehicleSummary v={outcome} />
      {outcome.detail && <p className="text-xs text-amber-800">Tester detail: {outcome.detail}</p>}
      <Button className="btn-cta h-11" onClick={onManual} data-testid={declined ? "part-exchange-enquiry-button" : "manual-review-enquiry-button"}>
        {declined ? "Ask about a part exchange" : "Request My Valuation"}
      </Button>
    </div>
  );
};
